<template>
  <div
    v-if="conversationGeography && conversationGeography.length > 0"
    class="border-top px-3 py-2 d-flex flex-column align-items-center"
  >
    <h4 class="card-title">
      {{ lastGeoFromPrimaryRecipient.normalized_address }}
    </h4>
    <div class="profile-pic mb-2 mt-1">
      <h5 v-if="conversationDetail.primary_recipient" class="mt-1 mb-0">
        {{ prettyPhoneNumber(conversationDetail.primary_recipient) }}
      </h5>
    </div>
    <div
      v-if="
        conversationGeography &&
        conversationGeography.length > 0 &&
        primaryRecipient
      "
      class="w-100"
      style="height: 500px"
    >
      <GoogleStaticMap
        :geography="conversationGeography"
        :recipients="conversationDetail.recipients"
        :recipientId="primaryRecipient.recipient_id"
      />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from "vuex";
import GoogleStaticMap from "@/components/GoogleStaticMap";
import errorHandler from "@/mixins/errorHandler";

export default {
  name: "AdminConversationGeography",
  mixins: [errorHandler],
  props: {
    conversationDetail: Object,
  },
  components: { GoogleStaticMap },
  data() {
    return {
      conversationGeography: [],
      fetchAbortController: null,
    };
  },
  computed: {
    ...mapGetters("agency", ["agencySettings"]),
    primaryRecipient() {
      if (this.conversationDetail && this.conversationDetail.recipients && this.conversationDetail.recipients.length > 0) {
        const recipient = this.conversationDetail.recipients.find(i => i.number == this.conversationDetail.primary_recipient);
        return !recipient ? null : recipient;
      }
      return null;
    },
    lastGeoFromPrimaryRecipient() {
      if (this.primaryRecipient && this.conversationGeography.length > 0) {
        const geoInfo = this.conversationGeography.find(geo => geo.recipient_id == this.primaryRecipient.recipient_id);
        return geoInfo ? geoInfo : {};
      }
      return {};
    },
    internationalDialCodeEnabled() {
      return this.agencySettings.enableInternational == "true";
    },
  },
  methods: {
    async loadConversationGeography() {
      try {
        this.fetchAbortController = new AbortController();
        const conversationId = this.conversationDetail.conversation_id;
        const resp = await this.$ConveyApi.locationsApi.getGeolocations({
          params: { conversationId },
          signal: this.fetchAbortController.signal,
        });
        this.conversationGeography = resp.data.data;
      } catch(err) {
        if (!this.isApiCanceled(err)) {
          console.log("[AdminConversationGeography:loadConversationGeography] ERROR: ", err);
        }
      }
    },
    prettyPhoneNumber(inPh) {
      let outPh;
      try {
        if (inPh.length == 10) {  //support for older phone number saved in db
          inPh = "1" + inPh;
        }
        if (!inPh.startsWith("+")) {  //support for older phone number saved in db
          inPh = "+" + inPh;
        }
        if (this.internationalDialCodeEnabled) {
          outPh = inPh.replace(/(\d{0,3})(\d\d\d)(\d\d\d)(\d\d\d\d)/, "$1-$2-$3-$4");
        }
        else {
          outPh = inPh.substring(2).replace(/(\d\d\d)(\d\d\d)(\d\d\d\d)/, "$1-$2-$3");
        }
      } catch (error) {
        outPh = inPh;
      }
      return outPh;
    },
  },
  watch: {
    conversationDetail: {
      async handler(conversation) {
        if (conversation && conversation.conversation_id) {
          await this.loadConversationGeography();
        }
      },
      deep: true,
      immediate: true,
    },
  },
  beforeDestroy() {
    if (this.fetchAbortController) {
      this.fetchAbortController.abort();
      this.fetchAbortController = null;
    }
  }
};
</script>
